import { SourcingOpenings } from 'api-clients/monolith';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import DotsVerticalIcon from '@/assets/icons/dots-vertical.svg';
import ExternalLinkIcon from '@/assets/icons/external-link.svg';
import { BullseyeLineIcon } from '@/components/icons/bullseye-line';
import { PlaneSendIcon } from '@/components/icons/plane-send';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useAuthContext } from '@/contexts/auth-context';
import { useHireUrl } from '@/hooks/use-hire-url';

interface MenuProps {
  opening: SourcingOpenings;
  onEditTargets: () => void;
  onPostJob: (opening: SourcingOpenings) => void;
}

export function Menu({ opening, onEditTargets, onPostJob }: MenuProps) {
  const { getHireApplicantTableUrl } = useHireUrl();
  const { canPostToJobBoards } = useAuthContext();

  const handlePostJobClick = () => {
    onPostJob(opening);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        <img src={DotsVerticalIcon} alt="Menu" />
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuItem onClick={onEditTargets}>
          <BullseyeLineIcon className="size-4 text-fx-neutral-400" />
          <FormattedMessage
            defaultMessage="Edit targets"
            description="Row menu: open hire goal / budget targets for this job"
          />
        </DropdownMenuItem>

        <DropdownMenuItem asChild>
          <Link
            to={getHireApplicantTableUrl(
              opening.brand_slug ?? 'no_brand',
              opening.location_id,
              opening.external_id,
            )}
            target="_blank"
          >
            <img src={ExternalLinkIcon} alt="" />
            <FormattedMessage
              defaultMessage="View in Hire"
              description="Row menu: deep link to applicant pipeline in Hire ATS"
            />
          </Link>
        </DropdownMenuItem>

        {canPostToJobBoards && (
          <DropdownMenuItem onClick={handlePostJobClick}>
            <PlaneSendIcon className="size-4 text-fx-neutral-400" />
            <FormattedMessage
              defaultMessage="Post Job"
              description="Action button label for posting a job to sourcing channels"
            />
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
